module.exports = __webpack_public_path__ + "img/health-guide-lungs.b9eb6cd1.png";